import {MODALITY, Modality} from '@domain/model/Account/Subscription/Subscription';
import {useExperiment} from '@lookiero/mendel-web-client';

interface UseMonthlyDefaultSubscriptionProps {
  modality?: Modality;
  isFirstOrder: boolean;
}

interface UseMonthlyDefaultSubscription {
  modality: Modality;
}

const EXPERIMENT = {
  name: 'grw_MonthlyDefault',
  variants: {
    V1: 'grw_MonthlyDefault_v1',
    CONTROL: 'grw_MonthlyDefault_control',
  },
};

export const useMonthlyDefaultSubscription = ({
  modality,
  isFirstOrder,
}: UseMonthlyDefaultSubscriptionProps): UseMonthlyDefaultSubscription => {
  const {control, v1} = useMonthlyDefaultSubscriptionExperiment({isFirstOrder});

  if (control) {
    return {modality: MODALITY.BIMONTHLY};
  } else if (v1) {
    return {modality: MODALITY.MONTHLY};
  } else if (modality && modality === MODALITY.ON_DEMAND) {
    return {modality: MODALITY.BIMONTHLY};
  } else {
    return {modality: modality || MODALITY.BIMONTHLY};
  }
};

interface useMonthlyDefaultSubscriptionExperimentResult {
  control: boolean;
  v1: boolean;
  notAssigned: boolean;
}

export const useMonthlyDefaultSubscriptionExperiment = ({
  isFirstOrder = false,
}: {
  isFirstOrder: boolean;
}): useMonthlyDefaultSubscriptionExperimentResult => {
  const {variant} = useExperiment({name: EXPERIMENT.name, enabled: isFirstOrder});

  return {
    control: variant === EXPERIMENT.variants.CONTROL,
    v1: variant === EXPERIMENT.variants.V1,
    notAssigned: !variant,
  };
};
